import { Component, h } from '@stencil/core';
import "../.././stories/Components/MessageBubble/VideoMessageBubble/VideoMessageBubble"
@Component({
  tag: 'chat-video-message-bubble',
  shadow: true
})
 class ChatVideoMessageBubble {

  render() {
    return (
      <div>
        <video-message 
          bgColor="#EFF1FA" 
          borderRadius="6px"
          padding="10px 10px 25px 10px" 
          videoSrc="https://www.w3schools.com/html/mov_bbb.mp4"
          time={new Date().toISOString()}>
        </video-message>  
      </div>
    );
  }
}

export { ChatVideoMessageBubble };
